import validate from "/home/runner/work/moduleplus-moduleplus.ch/moduleplus-moduleplus.ch/nuxt-app/node_modules/nuxt/dist/pages/runtime/validate.mjs";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}